import React from 'react';

export const CheckTickLg = ({ title }: { title: string }): JSX.Element => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <title>{title}</title>
    <g clipPath='url(#clip0_473_2184)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.183 6.3536L9.5001 17.0363L4.14648 11.6828L4.85359 10.9757L9.5001 15.6221L19.4759 5.64648L20.183 6.3536Z'
        fill='#009EAD'
      />
    </g>
    <defs>
      <clipPath id='clip0_473_2184'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
